export default {"src":"/intl/_next/static/media/moneyDollar.ebd8153d.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};